import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import confirmAction from '@components/Shared/Alert/confirmAction';

import { useDispatch, useSelector } from 'react-redux';
import { Card, CardBody, CardFooter, CardHeader } from '../../../../components/card/card';
import {
  cleanUpPersonListByPayroll,
  getPersonListPayrollToRun,
  ActinRunPyroll,
  cleanUpPeriodTimeList
} from '../../../../store/HR/Payroll/runPayrollSlice';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import Loading from '../../../../components/Shared/Loader/Loading';
import ModalComponent from '../../../../components/Modal/ModalComponent';
import AddQuickPay from './AddQuickPay';
import NtxTable from '../../../../components/DataTable/NtxTable';
import { useParams } from 'react-router-dom';
import Select from 'react-select';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import useGetPeriodTimeByPayroll from '@hooks/Payrolls/useGetPeriodTimeByPayroll';
import Partial from './Partial';
import Quick from './Quick';
import All from './All';
import CustomAlert from '@components/Shared/Alert/CustomAlert';

const AddRun = () => {
  const { payrollId } = useParams();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const [selectedIds, setSelectedIds] = useState([]);
  const [person, setPerson] = useState();
  const [period, setPeriod] = useState(null);
  const [type, setType] = useState('All');
  const [isProcessing, setIsProcessing] = useState(false); // حالة التحميل
  const { PeriodTimeList, optionPeriodTime, loading, error } = useGetPeriodTimeByPayroll(payrollId);
  const { PersonListByPayroll: data, loading2, error2 } = useSelector(state => state.runPayroll);

  useEffect(() => {
    if (payrollId && period) {
      dispatch(getPersonListPayrollToRun({ PayrollId: payrollId, PeriodId: period.value }));
    }
    // return () => {
    //   dispatch(cleanUpPersonListByPayroll());
    //   dispatch(cleanUpPeriodTimeList());
    // };
  }, [dispatch, period, payrollId]);

  useEffect(() => {
    return () => {
      dispatch(cleanUpPersonListByPayroll());
      dispatch(cleanUpPeriodTimeList());
    };
  }, []);

  useEffect(() => {
    if (!period && optionPeriodTime?.length > 0) {
      const defaultOption = optionPeriodTime.find(f => f.hasRun === false);
      if (defaultOption) {
        setPeriod(defaultOption);
      }
    }
  }, [optionPeriodTime, period]);

  const handleRunPayRoll = async () => {
    var msg1 =
      i18n.language === 'en'
        ? 'Please select more than one employee to perform the partial run. If you want to perform the operation for only one employee, please use the "Quick Pay" option.'
        : 'يرجى اختيار أكثر من موظف لتنفيذ التسيير الجزئي. إذا كنت ترغب بتنفيذ العملية لموظف واحد فقط، يُرجى استخدام خيار "Quick Pay".';
    if (type === 'Partial' && selectedIds?.length === 1) {
      CustomAlert({
        action: 'info',
        msg: msg1
      });
      return;
    }

    var msg2 =
      i18n.language === 'en'
        ? 'Are you sure you want to proceed with the run?'
        : 'سيتم تنفيذ عملية التسيير، هل أنت متأكد؟';

    const isConfirm = await confirmAction(msg2);
    if (!isConfirm) return;

    setIsProcessing(true); // تفعيل حالة التحميل

    try {
      const res = await dispatch(
        ActinRunPyroll({
          payrollId: payrollId,
          assignmentIds: type === 'ALL' ? [] : selectedIds,
          actionType:
            type === 'Partial'
              ? 'PartialRun'
              : type === 'All'
              ? 'Run'
              : type === 'Quick'
              ? 'QuickPay'
              : '',
          timePeriodId: period.value
        })
      ).unwrap();
      // debugger;
      if (res.status) {
        CustomAlert({ action: 'Add', msg: t('PayrollProcessedSuccessfully') });
      } else {
        CustomAlert({ action: 'Error' , msg: res.msg});
      }
    } catch (error) {
      CustomAlert({ action: 'Error' });
    } finally {
      setIsProcessing(false); // إلغاء حالة التحميل بغض النظر عن النتيجة
    }
  };
  const getDisplayText = () => {
    if (type === 'Quick') {
      if (selectedIds?.length === 1) {
        const employee = data.find(p => p.assignmentId === selectedIds[0]);
        return employee
          ? ` ( ${i18n.language === 'en' ? employee.personName : employee.personName2} )`
          : '';
      }
      return '';
    }
    return ` (${selectedIds?.length || 0} ${t('موظف')})`;
  };

  const radios = [
    { name: t('All'), value: 'All', icon: 'fa-globe' }, // الكل
    { name: t('Partial'), value: 'Partial', icon: 'fa-puzzle-piece' }, // جزئي
    { name: t('_Quick'), value: 'Quick', icon: 'fa-user' } // فردي
  ];

  return (
    <>
      <Breadcrumb
        BreadcrumbList={[
          {
            name: 'Home',
            link: ':moduleHome'
          },

          {
            name: t('AddRun'),
            link: null
          }
        ]}
        PageName={t('AddRun')}
      />

      <Card>
        <CardHeader className=' '>
          <div className='row'>
            <div className='col-xl-4'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Period-Month')}</label>
                <Select
                  isLoading={loading}
                  classNamePrefix='react-select'
                  className='w-100  '
                  isSearchable
                  // isClearable
                  options={optionPeriodTime?.filter(f => f.hasRun === false)}
                  onChange={option => {
                    setPeriod(option === null ? null : option);
                    setSelectedIds([]);
                  }}
                  value={period}
                  placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: base => ({ ...base, zIndex: 9999 })
                  }}
                  formatOptionLabel={option => (
                    <div className='d-flex justify-content-between   '>
                      {/* <div className=''>{option.label}</div> */}
                      <div className='text-theme fw-bold'>{option.label}</div>
                    </div>
                  )}
                />
              </div>
            </div>
            <div className='col-xl-8 '>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Type')}</label>
                <ButtonGroup className='w-100  '>
                  {radios.map((radio, idx) => (
                    <ToggleButton
                      className='w-100 d-flex fw-bold align-items-center justify-content-center gap-2 m-0'
                      key={idx}
                      id={`radio-${idx}`}
                      type='radio'
                      variant={'outline-theme'}
                      name='isActive'
                      value={''}
                      checked={type === radio.value}
                      onChange={() => {
                        setType(radio.value);
                        setSelectedIds([]);
                      }}
                    >
                      <i className={`fa ${radio.icon} me-1`}></i> {radio.name}
                    </ToggleButton>
                  ))}
                </ButtonGroup>
              </div>
            </div>
          </div>
        </CardHeader>

        <Loading loading={loading2} error={error2}>
          <CardBody>
            {
              {
                All: <All Persons={data} onIdsChange={setSelectedIds} />,
                Partial: <Partial Persons={data} onIdsChange={setSelectedIds} />,
                Quick: <Quick Persons={data} onIdsChange={setSelectedIds} />
              }[type]
            }
          </CardBody>
        </Loading>
        <CardFooter className='bg-theme bg-opacity-15'>
          <div className='d-flex flex-column'>
            {/* <button
              disabled={selectedIds?.length === 0}
              type='button'
              className={`btn btn-lg  w-100 rounded-1 ${
                selectedIds?.length === 0 ? 'btn-secondary' : 'btn-theme'
              }`}
              onClick={() => handleRunPayRoll()} // Define this function for salary process
            >
              <i className='fa fa-money-bill-alt me-2'></i>
              <span>
                {i18n.language === 'en' ? 'Process Salary' : 'تسيير الراتب'}
                <span className='ms-2 fw-bold'>{getDisplayText()}</span>
              </span>
            </button> */}
            <button
              disabled={selectedIds?.length === 0 || isProcessing} // تعطيل الزر أثناء التحميل
              type='button'
              className={`btn btn-lg w-100 rounded-1 ${
                selectedIds?.length === 0 ? 'btn-secondary' : 'btn-theme'
              }`}
              onClick={handleRunPayRoll}
            >
              {isProcessing ? (
                <>
                  <span
                    className='spinner-border spinner-border-sm me-2  '
                    role='status'
                    aria-hidden='true'
                  ></span>
                  {i18n.language === 'en' ? 'Processing...' : 'جاري التسيير...'}
                </>
              ) : (
                <>
                  <i className='fa fa-money-bill-alt me-2'></i>
                  <span>
                    {i18n.language === 'en' ? 'Process Salary' : 'تسيير الراتب'}
                    <span className='ms-2 fw-bold'>{getDisplayText()}</span>
                  </span>
                </>
              )}
            </button>
          </div>
        </CardFooter>
      </Card>

      <style>{`
      
      .btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show { 

        border-color: rgba(var(--bs-theme-rgb), 1);
        background-color: rgba(var(--bs-theme-rgb), 1) ;
        }

        .spinner-border {
          vertical-align: middle;
        }
.btn:disabled {
  opacity: 0.7;
}


  body .react-select__control {
          border-radius: 0px;
          }

          .form-check-input {
              width: 1.8em;
              height: 1.8em;
          }

      `}</style>
    </>
  );
};

export default AddRun;

// {
//   payrollId: payrollId,
//   assignmentId: null,
//   actionType: 'Run',
//   timePeriodId: values.timePeriodId,
// }
